export interface CompanyForumComment {
  comment_msg: string;
  file_upload: any;
}

export interface CompanyForumReplyComment {
  reply_msg: string;
  comment_id: string;
}

export interface CompanyForumListing {
  comment_id: string;
  comment_msg: string;
  created_on: Date | string;
  file_upload: string;
  replyMessages: ReplyMessageDetail[];
  usr_name: string;
  usr_photo: string;
  usr_lastname: string;
}

export interface ReplyMessageDetail {
  created_on: string | Date;
  reply_msg: string;
  usr_name: string;
  usr_photo: string;
  usr_lastname: string;
}